// extracted by mini-css-extract-plugin
export var bottomRightDock = "_17-0";